import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.housingStocks[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

export const selectHousingStocks = (state) => state.housingStocks?.housingStocks;
export const selectHousingStocksLoading = () => isLoadingSelector('getHousingStocksStatus');

export const selectCreateHousingStockLoading = isLoadingSelector('createHousingStockStatus');
export const selectUpdateHousingStockLoading = isLoadingSelector('updateHousingStockStatus');
export const selectDeleteHousingStockLoading = isLoadingSelector('deleteHousingStockStatus');
